import * as React from 'react'
import ScrollAnimation from 'react-animate-on-scroll'
import ContentLoader from 'react-content-loader'
import CopyToClipboard from 'react-copy-to-clipboard'
import { withRouter } from 'react-router-dom'
import Workbench from 'src/components/Workbench'
import Back from 'src/components/Back';
import { Auth0Context } from '../contexts/auth0'
import { MergedContexts } from '../contexts/merged'
import { IAPIKeyState, IPropState } from '../models/views/IApiKey'
import { bindContexts } from '../utils/bindContexts'
import copyIcon from './../assets/images/copyIcon.png'
import { APIContext, getAllApiKeysURI } from '../contexts/api'
import { AxiosInstance, AxiosResponse } from 'axios'
import { logError } from 'src/utils/Error'
import * as Mui from '@material-ui/core'
import { ReactComponent as AddIcon } from '../assets/images/svgs/add.svg'
import ApiKeyRow from 'src/components/ApiKeyRow'
import NewApiKeyDialog from 'src/components/NewApiKeyDialog'
import 'src/assets/css/views/ApiKey.css'
import { Snackbar } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import IApiKey from 'src/models/IApiKey'
import IRoot from 'src/models/components/IRoot'
import { AppEnv } from 'src/utils/appenv'
import IPage from 'src/models/IPage'

class APIKey extends React.Component<IPropState, IAPIKeyState> {
    static contextType = MergedContexts;

    public isThisMounted = false;
    public token_str = '';
    constructor(props: IPropState) {
        super(props)
        this.state = {
            ready: false,
            token: '',
            copied: false,
            apiKeys: [],
            isDialogOpen: false,
        }
    }

    public async componentDidMount() {
        const { getTokenSilently, loading } = this.context
        const root: IRoot | undefined = this.context.rootRef.current
        this.isThisMounted = true
        this.props.setViewName && this.props.setViewName("API Keys")
        const token = !loading ? await getTokenSilently() : undefined
        root && root._links && root._links['apikeys'] && this.getApiKeys()
        this.setState({ token, ready: true })
    }

    public componentWillUnmount() {
        this.isThisMounted = false
    }

    private async getApiKeys() {
        const { catalogAPI } = this.context
        const api = catalogAPI as AxiosInstance

        await api.get(getAllApiKeysURI())
            .then((resp: AxiosResponse<IPage<IApiKey>>) => {
                if (this.isThisMounted) {
                    this.setState({ apiKeys: resp.data._embedded?.apikeys ?? [] })
                }
            })
            .catch(e => {
                if (this.isThisMounted) {
                    logError(e)
                }
            });
    }

    private async updateApiKey(apiKey: IApiKey) {

        const { catalogAPI } = this.context
        const api = catalogAPI as AxiosInstance

        const endpoint = apiKey._links['update apikey'].href
        await api.put(endpoint, apiKey)
            .catch(logError);

    }

    private async deleteApiKey(apiKey: IApiKey) {

        const { catalogAPI } = this.context
        const api = catalogAPI as AxiosInstance

        const endpoint = apiKey._links['delete apikey'].href
        await api.delete(endpoint, { data: apiKey })
            .catch(logError);

    }

    public render() {
        const { ready, token, copied, apiKeys, isDialogOpen } = this.state
        const root: IRoot | undefined = this.context.rootRef.current

        const contentLoader = (
            <div className={ready ? 'feed-hidden loaderfadeOut col' : 'feed col'}>
                <div className="dataLoader_parent d-flex" data-testid="loader">
                    <div className="dataLoader pad_0 col">
                        <ContentLoader className="placeholderList" viewBox="0 0 446 15" speed={2}>
                            <rect x="5" y="8" rx="0" ry="0" width="30" height="6" />
                        </ContentLoader>
                        <ContentLoader className="placeholderDivider w-100" height={10} speed={2}>
                            <rect x="0" y="5" height="2" />
                        </ContentLoader>
                        <ContentLoader viewBox="0 0 446 18" speed={2}>
                            <rect x="5" y="8" rx="0" ry="0" width="40" height="6" />
                        </ContentLoader>
                        <ContentLoader viewBox="0 0 446 50" speed={2}>
                            <rect x="5" y="8" rx="0" ry="0" width="220" height="3" />
                            <rect x="5" y="16" rx="0" ry="0" width="220" height="8" />
                        </ContentLoader>
                    </div>
                </div>
            </div>
        )

        const handleCopiedToastOpen = (text: string) => {
            if (text) this.setState({ copied: true })
        }
        const handleSnackbarClose = () => this.setState({ copied: false })
        const handleDialogOpen = () => this.setState({ isDialogOpen: true })
        const handleDialogClose = () => this.setState({ isDialogOpen: false })
        const handleAddApiKey = (apiKey: IApiKey) => this.setState({ apiKeys: [...apiKeys, apiKey] })
        const handleUpdateApiKey = (apiKey: IApiKey) => this.updateApiKey(apiKey)
        const handleRemoveApiKey = (apiKey: IApiKey) => this.deleteApiKey(apiKey).then(() => {
            if (apiKey.name === 'default') {
                this.getApiKeys()
                return
            }

            apiKeys.splice(apiKeys.findIndex(a => a.id === apiKey.id), 1);
            this.setState({ apiKeys: apiKeys })
        })

        // in matatika-ce the catalog returns an access token, no ability to create api clients
        const newClientDisabled = !root?._links['new apikey']

        return (
            <>
                <Workbench>
                    <div className="w-100" data-testid="resolved">
                        {ready ? (
                            <div className="full_pageContent clearfix">
                                <Back />
                                <ScrollAnimation animateIn="fadeIn" offset={10}>
                                    <h1>Developer Token</h1>
                                    <div className="form-group">
                                        <small className="form-text">
                                        This is a short-lived API token for testing and development.
                                        </small>
                                        <CopyToClipboard
                                            onCopy={handleCopiedToastOpen}
                                            text={token}
                                        >
                                            <div className="input_with_copy_icon col-4 input-group">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={token || ''}
                                                    name="token"
                                                    id="token"
                                                    onChange={() => { return }}
                                                />
                                                <div
                                                    className="m_0 input-group-append"
                                                    data-testid="copyButton"
                                                >
                                                    <img id="copy-btn" src={copyIcon} alt="copy" />
                                                </div>
                                            </div>
                                        </CopyToClipboard>
                                    </div>
                                    <Mui.Grid
                                        container
                                        justifyContent='space-between'>
                                        <Mui.Grid
                                            item
                                            xs={6}
                                            container>
                                            <div>
                                                <h1>{AppEnv.APP_ENVIRONMENT === 'distribution' ? 'Tokens' : 'Clients'}</h1>
                                                <small className="form-text">{root && root._links && root._links['apikeys'] ?
                                                        AppEnv.APP_ENVIRONMENT === 'distribution' ? 'API Tokens to access your workspaces.'
                                                            : 'Long-lived api clients for managing App or 3rd party access to your workspaces.'
                                                        : 'Contact your account owner to create api clients'
                                                    }</small>
                                            </div>
                                        </Mui.Grid>
                                        <Mui.Grid
                                            item
                                            xs={6}
                                            container
                                            direction='row-reverse'>
                                            <Mui.Tooltip

                                                arrow
                                                title={newClientDisabled ? AppEnv.APP_DISABLED_FEATURE_DEFAULT_TOOLTIP_TITLE : ""}>
                                                {/* disabled MUI components must be wrapped by another element to display a tooltip on hover
                                                    https://v4.mui.com/components/tooltips/#disabled-elements */}
                                                <span>
                                                    <Mui.Button
                                                        variant='contained'
                                                        disabled={newClientDisabled}
                                                        startIcon={(
                                                            <Mui.SvgIcon>
                                                                <AddIcon />
                                                            </Mui.SvgIcon>
                                                        )}
                                                        onClick={handleDialogOpen} >
                                                        {AppEnv.APP_ENVIRONMENT === 'distribution' ? "New token" : "New client"}
                                                    </Mui.Button>
                                                </span>
                                            </Mui.Tooltip>
                                        </Mui.Grid>
                                    </Mui.Grid>
                                    {isDialogOpen &&
                                        <NewApiKeyDialog
                                            handleClose={handleDialogClose}
                                            handleAddApiKey={handleAddApiKey}
                                            handleCopyClientCredentials={handleCopiedToastOpen} />}
                                    <div className="apikey-list">
                                        {apiKeys.length ? (
                                            <>
                                                {apiKeys.map(a => (
                                                    <ApiKeyRow
                                                        key={a.id}
                                                        apiKey={a}
                                                        handleUpdateApiKey={handleUpdateApiKey}
                                                        handleRemoveApiKey={handleRemoveApiKey}
                                                        handleCopyClientIdOrAccessToken={handleCopiedToastOpen}>
                                                    </ApiKeyRow>
                                                )
                                                )}
                                            </>
                                        ) : null }
                                    </div>
                                </ScrollAnimation>
                            </div>
                        ) : contentLoader}

                    </div>
                </Workbench>
                <Snackbar
                    open={copied}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    autoHideDuration={3000}
                    onClose={handleSnackbarClose}>
                    <Alert severity='success'>Copied</Alert>
                </Snackbar>
            </>
        )
    }
}

export const APIKeyWithContext = bindContexts(APIKey, [
    Auth0Context,
    APIContext
])
export default withRouter(APIKeyWithContext)
